<template>
  <v-container>
    <template>
      <v-card class="mt-0">
        <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
          <v-spacer/>
        <v-btn
        icon
        @click="showFilters = !showFilters"
      >
        <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
        </v-card-title>
    
         <v-expand-transition>
      <div v-show="showFilters">
        <v-divider></v-divider>
       <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
              <v-combobox
                v-model="vehicle"
                :items="uniqueVehicles"
                prepend-icon="mdi-truck"
                label="Όχημα"
                chips
                multiple
                clearable
              >
                <template v-slot:selection="{ attrs, item, select, selected }">
                  <v-chip
                    v-bind="attrs"
                    :input-value="selected"
                    close
                    @click="select"
                    @click:close="remove(vehicle, item)"
                  >
                    <strong>{{ item }}</strong
                    >&nbsp;
                  </v-chip>
                </template>
              </v-combobox>
            </v-col>
            <v-col cols="12" sm="4">
              <v-select
                v-model="mark"
                :items="overdueDropDown"
                :suffix="fi"
                label="Σήμανση"
                prepend-icon="mdi-clipboard-alert"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
            <v-select
                v-model="invoicingPeriod"
                :items="uniqueInvoiceYears"
                :suffix="fiDate"
                label="Έτος χρήσης"
                prepend-icon="mdi-calendar"
                clearable
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4">
            <v-select
                v-model="paymTerms"
                :items="paymTermsDropDown"
                :suffix="fiPaym"
                label="Τρόπος Πληρωμής"
                prepend-icon="mdi-cash"
                multiple
                chips
                clearable
              ></v-select>
            </v-col>
             <v-col cols="12" sm="4">
            <v-text-field
                v-model="remarksFilter"
                label="Σχόλια"
                prepend-icon="mdi-notes"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4">
            <v-combobox
                v-model="invoiceTypeFilter"
                :items="uniqueDesc"
                label="Τύπος Τιμολογίων"
                prepend-icon="mdi-notes"
                chips
                multiple
                clearable
              ></v-combobox>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-expand-transition>
      </v-card>
    </template>

  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Τιμολόγια</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
            <v-spacer></v-spacer>
    <v-btn color="primary white--text" @click="sendInvoices" :disabled="toExport.length < 1">
        <v-icon>mdi-send</v-icon>Αποστολη
    </v-btn> 
    <v-btn icon color="primary white--text" @click="attachDialog = true" :disabled="toExport.length < 1">
        <v-icon>mdi-attachment</v-icon>
    </v-btn> 
    </v-card-title>
    <v-data-table
      :headers="showHeaders"
      :items="invoices"
      :search="search"
      loading: false
      item-key="Id"
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      show-select
      @item-selected="itemSelected"
      @toggle-select-all="itemSelectAll"
      @current-items="getFilteredInvoices"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
        <v-btn
          icon
          :to="'/invoice/details/'+item.Id"
        >
         <v-icon>mdi-file-document</v-icon>
        </v-btn>
     </template>
     <template v-slot:item.Kind3="{ item }">
       <span v-if="item.Kind == 'Item'">Τιμολόγιο Πώλησης</span>
        <span v-else>Τιμολόγιο Παροχής υπηρεσιών</span>
    </template>

     <template v-slot:item.PlateNumber="{ item }">
       <span v-if="item.PlateNumber == 'nan'">-</span>
        <span v-else>{{ item.PlateNumber }}</span>
    </template>
     <template v-slot:item.NetValue="{ item }">
       {{ tocurr(item.NetValue) }}
    </template>
     <template v-slot:item.PaymTerm="{ item }">
       <span><v-icon>{{ paym2icon(item) }}</v-icon></span>
    </template>
     <template v-slot:item.InvoiceId="{ item }">
       <v-chip label :color="odChip(item)" >{{ item.InvoiceId }}</v-chip>
    </template>
    <template v-slot:item.TotalValue="{ item }">
       {{ tocurr(item.TotalValue) }}
    </template>
    <template v-slot:item.VatValue="{ item }">
       {{ tocurr(item.VatValue) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
        Mark: {{ item.Mark }}
      </td>
    </template>
  <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

               
               
                <div class="text-right" v-if="header.value == 'PaymTerm'">
                  Σύνολο:
                </div>

                <div class="text-right" v-if="header.value == 'TotalValue'">
                    {{ tocurr(invoicesTotal) }}
                </div>
                
                <div class="text-right" v-if="header.value == 'VatValue'">
                   {{ tocurr(invoicesNet*0.24) }}
                </div>
                <div class="text-right" v-if="header.value == 'NetValue'">
                   {{ tocurr(invoicesNet) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>


    </v-data-table>
  </v-card>
  <v-dialog v-model="attachDialog" max-width="900">
    <v-card>
      <v-card-title>
        <span class="headline">Επισύναψη PDF ανά Τιμολόγιο</span>
      </v-card-title>
      <v-card-text>
        <v-row>
        <v-col cols="12" sm="10">
        <v-text-field
          v-model="recipientEmail"
          label="Email παραλήπτη"
          prepend-icon="mdi-email"
          clearable
          type="email"
          :rules="[
            v => !v || /.+@.+\..+/.test(v) || 'Μη έγκυρο email'
          ]"
          class="mb-4"
        />

        </v-col>
        <v-col cols="12" sm="2">
          <v-switch
            v-model="draftEmail"
            label="Πρόχειρο;"
          />
        </v-col>



        </v-row>
        <v-data-table
          :headers="tableHeaders"
          :items="selectedInvos"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item.fileUpload="{ item }">
            <v-file-input
              :value="invoiceFiles[item.Id]"
              accept=".pdf,application/pdf"
              prepend-icon="mdi-paperclip"
              clearable
              @change="handleFileChange($event, item.Id)"
              outlined
              dense
              show-size
              :error-messages="fileErrors[item.Id]"
            />
            <v-btn 
              icon 
              small 
              v-if="pdfPreviews[item.Id]" 
              @click="openPdfPreview(item.Id)"
              title="Προεπισκόπηση PDF"
              >
              <v-icon>mdi-eye</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="attachDialog=false">Ακύρωση</v-btn>
        <v-btn
          color="primary"
          :disabled="!canSend"
          @click="sendInvoicesWithAttachments"
        >
          <v-icon left>mdi-send</v-icon>
          Αποστολή
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-dialog v-model="previewDialog" max-width="900px" persistent>
  <v-card>
    <v-toolbar flat color="white">
      <span class="subtitle-1">
        Προεπισκόπηση PDF
      </span>
      <v-spacer/>
      <v-btn icon @click="previewDialog = false"><v-icon>mdi-close</v-icon></v-btn>
    </v-toolbar>
    <v-divider></v-divider>
    <v-card-text style="height:700px;">
      <embed 
        v-if="previewUrl" 
        :src="previewUrl" 
        type="application/pdf" 
        width="100%" 
        height="100%"
      />
      <div v-else>Δεν υπάρχει διαθέσιμο PDF</div>
    </v-card-text>
  </v-card>
</v-dialog>
</template>
</v-container>

</template>

<script>
import { map as _map } from 'lodash';
import {sumBy as _sumBy} from "lodash";

export default {
  computed: {
  
    uniqueVehicles () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniq(this.invoices, 'PlateNumber');
    },
    uniqueDesc () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniq(this.invoices, 'Description');
    },
    uniqueInvoiceYears () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniqYears(this.invoices);
    },
    fi() {
      if (!this.mark) return;
      return this.tocurr(this.sumField(this.filteredInvoices, 'TotalValue'))
    },
    fiDate() {
      if (!this.invoicingPeriod) return;
      return this.tocurr(this.sumField(this.filteredInvoices, 'TotalValue'))
    },
    fiPaym() {
      if (!this.paymTerms.length) return;
      return this.tocurr(this.sumField(this.filteredInvoices, 'TotalValue'))
    },
    canceled () {
      return _map(this.invoices.filter(x => (x.Status == "Ακυρωμένο" || x.Status == "Ακυρωτικό" )), 'Id');
    },
    invoicesF () {
        if (this.selectedInvos.length) return this.selectedInvos;
        return this.filteredInvoices;
    },
    invoicesTotal () {
       return _sumBy(this.invoicesF.filter(x => x.Status === "Κανονικό"), 'TotalValue') -
_sumBy(this.invoicesF.filter(x => x.Status === "Πιστωτικό"), 'TotalValue')
    },
    invoicesNet () {
       return _sumBy(this.invoicesF.filter(x => x.Status === "Κανονικό"), 'NetValue') -
_sumBy(this.invoicesF.filter(x => x.Status === "Πιστωτικό"), 'NetValue')
    },
    showHeaders() {
        if (this.$vuetify.breakpoint.smAndDown) {
            return this.headers.filter(h => !(['Id', 'Description', 'Status', 'VatValue']).includes(h.value));
        } else {
            return this.headers;
        }
    },
    tableHeaders() {
      return [
        { text: 'ID', value: 'Id' },
        { text: 'Αρ. Τιμολογίου', value: 'DocNumber' },
        { text: 'Tύπος Τιμολογίου', value: 'Description' },
        { text: 'Ημ/νια', value: 'Date' },
        { text: 'Αρ. Κυκλοφ.', value: 'PlateNumber' },
        // Add more invoice-relevant columns if desired...
        { text: 'PDF Αρχείο', value: 'fileUpload' },
      ];
    },
    canSend() {
      // All invoices must have a file
      return (
        this.selectedInvos.length > 0 // &&
        // this.selectedInvos.every(inv => !!(this.invoiceFiles[inv.Id])) &&
        //Object.values(this.fileErrors).every(msg => !msg)
      );
    },
  },
  data() {
    return {

      overdueDropDown: [
        {value: "paid", text:  "Εξωφλημένο"},
        {value: "unpaid", text:  "Ανεξώφλητο"},
        {value: "overdue", text:  "Καθυστερημένο"},
        {value: "canceled", text:  "Ακυρωμένο"},
        ],
      paymTermsDropDown: [
        {value: 1, text:  "Μετρητοίς", icon: 'mdi-cash'},
        {value: 2, text:  "Με πίστωση 10 ημερών", icon: 'mdi-calendar-clock'},
        {value: 3, text:  "Πληρωμή με κάρτα", icon: 'mdi-credit-card-chip'},
        {value: 4, text:  "Κατάθεση σε τράπεζα", icon: 'mdi-bank-transfer'},
        {value: 5, text:  "Επιταγή", icon: 'mdi-checkbook'},
        {value: 6, text:  "Αντικαταβολή", icon: 'mdi-hand-coin'},
        {value: 7, text:  "Επί Πιστώσει", icon: 'mdi-calendar'},
        ],
      filteredInvoices: [],
      invoicingPeriod: '',
      paymTerms: '',
      remarksFilter: '',
      invoiceTypeFilter: '',
      expanded: [],
      showFilters: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      info: {
      name: '',
      address: '',
      telephone:'',
      nino: '',
      doi: '',
      city: ''
      },
      overdue: [],
      unpaid: [],
      paid: [],
      toExport: [],
      attachDialog: false,
      attachedFiles: [],
      selectedInvos: [],
      invoiceFiles: {}, // { [invoiceId]: File }
      fileErrors: {},   // { [invoiceId]: String }
      pdfPreviews: {}, // { [invoiceId]: objectURL }
      previewDialog: false,
      previewUrl: null,
      search: '',
      customer_id: this.$route.params.id,
      mark: '',
      draftEmail: false,
      vehicle: [],
      invoices: [],
      recipientEmail: "",
      headers: [
          {
            text: 'Α/A',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
            filter: (value) => {
            if (!this.mark) return true;
            if (this.mark == "paid") return this.paid.includes(value);
            if (this.mark == "unpaid") return this.unpaid.includes(value);
            if (this.mark == "overdue") return this.overdue.includes(value);
            if (this.mark == "canceled") return this.canceled.includes(value);
            },
          },
          {
            text: 'Αρ. Τιμολογίου',
            align: 'start',
            //sortable: false,
            value: 'InvoiceId',
            width: '10%',
          },
          { text: 'Ημερομηνία', value: 'Date', width: '10%',
          filter: (value) => {
            if (!this.invoicingPeriod) return true;
            if (this.invoicingPeriod == value.slice(0,4)) return true;
            },
          
           },
          { text: 'Τυπος', value: 'Description',
          filter: (value) => {
            if (this.invoiceTypeFilter.length == 0) return true;
            return this.invoiceTypeFilter.includes(value);
          }},
           { text: 'Κατάσταση', value: 'Status' },
          { text: 'Οχημα', value: 'PlateNumber',
          filter: (value) => {
            if (this.vehicle.length == 0) return true;
            return this.vehicle.includes(value);
          }},
          { text: 'Τρ. Πληρ.', value: 'PaymTerm', width: '5%',
          filter: (value) => {
            if (this.paymTerms.length == 0) return true;
            return this.paymTerms.includes(value);
          }},
          { text: 'Καθαρή αξία', value: 'NetValue', align: 'end' },
          { text: 'ΦΠΑ', value: 'VatValue', align: 'end' },
          { text: 'Συνολο', value: 'TotalValue', align: 'end' },
         // { text: 'ΑΑΔΕ ΜΑΡΚ', value: 'AadeMark', align: 'center' },
          { text: 'Actions', value: 'actions' }, 
          { text: 'Σχόλια', value: 'Remarks' ,
          filter: (value) => {
            if (!this.remarksFilter) return true;
            if (value) return value.includes(this.remarksFilter);
            return true;
          }},
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  
  async created() {
      try {
        this.loading = true;
        const resp1 = await this.$api.get('/customers/'+this.$route.params.id);
        this.invoices = resp1.data.Invoices;
        const resp2 = await this.$api.get('/customers/'+this.$route.params.id+ '/due');
        this.overdue = resp2.data.overdue;
        this.paid = resp2.data.paid;
        this.unpaid = resp2.data.unpaid;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  getFilteredInvoices (invos) {
    this.filteredInvoices = invos;
  },
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
  odChip(item) {
      if (this.paid.includes(item.Id)) return "green-accent-3";
      if (this.unpaid.includes(item.Id)) return "orange";
      if (this.overdue.includes(item.Id)) return "red";
      if (item.Status == "Ακυρωτικό" || item.Status == "Ακυρωμένο") return "secondary";
      if (item.TypeCode == 101) return "blue lighten-2";
      return "light-blue lighten-1";
    },
  close () {
        this.timdialog = false
  },
    tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.reduce((a, b) => a + (b[key] || 0), 0);
    },
    
    paym2icon(paym) {
      var result = this.paymTermsDropDown.find(item => item.value === paym.PaymTerm);
      return result.icon ;
    },
    async sendInvoices() {
        const options = {
          method: 'POST',
          headers: { 'content-type': 'application/json;charset=utf-8' },
          data:  this.toExport, //this.repairs.map(e=>e.Id),
          url: '/invoices/send-invoices',
        };
    
       const res = await this.$api(options);
       if (res.data.status=="ok") {
        alert('Τα τιμολόγια εστάλησαν επιτυχώς!');
       }
    },
    handleFileChangeOld(fileArr, invoiceId) {
      // fileArr is always array (or single file), but v-file-input can send [] if cleared
      const file = Array.isArray(fileArr) ? fileArr[0] : fileArr;
      // Validate PDF
      if (file && file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
        this.$set(this.fileErrors, invoiceId, "Μόνο PDF επιτρέπονται");
        this.$set(this.invoiceFiles, invoiceId, null);
      } else {
        this.$set(this.invoiceFiles, invoiceId, file);
        this.$set(this.fileErrors, invoiceId, "");
      }
    },
    openPdfPreview(invoiceId) {
      this.previewUrl = this.pdfPreviews[invoiceId] || null;
      this.previewDialog = !!this.previewUrl;
    },
    handleFileChange(fileArr, invoiceId) {
      const file = Array.isArray(fileArr) ? fileArr[0] : fileArr;
      if (file && file.type !== "application/pdf" && !file.name.endsWith(".pdf")) {
        this.$set(this.fileErrors, invoiceId, "Μόνο PDF επιτρέπονται");
        this.$set(this.invoiceFiles, invoiceId, null);
        this.$set(this.pdfPreviews, invoiceId, null); // clear preview!
      } else if (file) {
        this.$set(this.invoiceFiles, invoiceId, file);
        this.$set(this.fileErrors, invoiceId, "");
        const url = URL.createObjectURL(file);
        this.$set(this.pdfPreviews, invoiceId, url); // 👈 Add this line!
      } else {
        URL.revokeObjectURL(this.pdfPreviews[invoiceId]);
        this.$set(this.invoiceFiles, invoiceId, null);
        this.$set(this.pdfPreviews, invoiceId, null);
      }
    },

    async sendInvoicesWithAttachments() {
      // Prepare form data
      const formData = new FormData();
      // this.toExport.forEach((invo_id) => {
      //   formData.append('invoice_ids', invo_id); // Array of IDs
      // });
      
      // this.attachedFiles.forEach((file) => {
      //   formData.append('files', file);
      // });

      // Compose for payload:
      // Map: [{invoice_id, file}]
      if (this.recipientEmail) {
        formData.append('recipient_email', this.recipientEmail);
      }
      if (this.draftEmail) {
        formData.append('draft', true);
      }
      this.selectedInvos.forEach(inv => {
        formData.append('invoice_ids', inv.Id); // API expects multiple IDs
        // For files, use the same key for each, or "files[INV_ID]" if backend allows
        formData.append('files', this.invoiceFiles[inv.Id]);
      });


      // API call
      try {
        this.loading = true;
        const res = await this.$api.post(
          '/invoices/send-invoices-garage',
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          }
        );
        if (res.data.status === "ok") {
          alert('Τα τιμολόγια εστάλησαν επιτυχώς με τα συνημμένα!');
          this.attachDialog = false;
          this.attachedFiles = [];
        } else {
          alert('Κάτι πήγε στραβά στην αποστολή.');
        }
      } catch (e) {
        alert('Σφάλμα αποστολής.');
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    uniqYears(items) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      let year = 0;
      for (let val of items) {
        year = val['Date'].slice(0,4);
        //console.log(year) //.getFullYear();
        //If item is already added then move to the next item
        if (itemsFound[val[year]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(year);

        //Mark it as added
        itemsFound[year] = true;
      }

      //Return the uniques
      return uniques;
    },
   
   itemSelected(selected) {
    if (selected.value) {
      this.toExport.push(selected.item.Id);
      this.selectedInvos.push(selected.item)
    } else {
      const index = this.toExport.indexOf(selected.item.Id);
        
      this.toExport.splice(index, 1);
      this.selectedInvos.splice(index, 1)
    }
  },
  itemSelectAll(selected) {
    if (selected.value) {
      this.toExport = []
      this.selectedInvos = []
      for (let item in selected.items) {
        this.toExport.push(item.Id);
        this.selectedInvos.push(selected.items[item])
      }
    } else {
      this.toExport = []
      this.selectedInvos = []
    }
  },
    uniq(items, key) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      for (let val of items) {
        //If item is already added then move to the next item
        if (itemsFound[val[key]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(val[key]);

        //Mark it as added
        itemsFound[val[key]] = true;
      }

      //Return the uniques
      return uniques;
    },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },
  removeFile(idx) {
    this.attachedFiles.splice(idx, 1);
  },

  }
}
</script>
